function toCustomEventName(eventName) {
  // popup_shown → popup:shown, popup_converted → popup:converted
  const idx = eventName.indexOf('_')
  if (idx === -1) return eventName
  return eventName.slice(0, idx) + ':' + eventName.slice(idx + 1)
}

/**
 * Fire an event to window.dataLayer and document.
 * Silent on errors (missing dataLayer, etc.).
 * @param {string} eventName - snake_case (e.g. "popup_shown")
 * @param {object} payload - extra fields beyond `event` name
 */
export function fireEvent(eventName, payload) {
  // 1. dataLayer (GTM/GA4)
  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: eventName, ...payload })
  } catch {
    /* ignore — tracker may have replaced dataLayer with a setter */
  }

  // 2. CustomEvent (other trackers, app code)
  try {
    document.dispatchEvent(
      new CustomEvent(toCustomEventName(eventName), { detail: { ...payload } })
    )
  } catch {
    /* ignore */
  }
}
